import { Button, Modal } from "antd";
import moment from "moment";

import { getSubscriptionUserInfo } from "../../utils/utils";

const SubscriptionModal = ({ isOpen, handleCancel }) => {
  const subscription = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscription?.validTo);
  const isExpired = validToDate.isBefore(currentDate);

  return (
    <Modal
      title="Subscription expired"
      open={isOpen}
      centered
      footer={[
        <Button
          key="ok"
          type="primary"
          className="theme-btn"
          onClick={() => handleCancel()}
        >
          OK
        </Button>,
      ]}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <>
        {isExpired
          ? "Your subscription has expired. Please renew your subscription to continue using the service."
          : "You do not have an active subscription. Please subscribe to continue using the service."}
      </>
    </Modal>
  );
};

export default SubscriptionModal;
